import { SeasonAnomalyHit } from '../../types/AiForecasting';

export function other_anomalies_title(sku_label?: string): string {
  return `Other times ${sku_label || 'this SKU'} is an anomaly`;
}

export function other_anomaly_summary(hit: SeasonAnomalyHit): string {
  const week_word = hit.season_week_count === 1 ? 'week' : 'weeks';
  return `${hit.holiday_start} – ${hit.holiday_end} · ${hit.season_cases} cases in ${hit.season_week_count} holiday ${week_word} (avg ${hit.season_week_avg}/week vs ${hit.offseason_week_avg} regular)`;
}
